import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MuiDialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'

import { Text } from './Text'
import { Button } from './Button'
import { Icon } from './Icon'
import { Card } from './Card'

const typeStringOrReact = PropTypes.oneOfType([PropTypes.string, PropTypes.element])

class ModalGeneric extends Component {
  constructor (props) {
    super(props)
    this.state = { visible: !!props.visible }
    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)
  }

  componentDidMount () {
    this.props.setShow && this.props.setShow(this.show)
    this.props.setHide && this.props.setHide(this.hide)
  }

  componentDidUpdate (prevProps) {
    if (this.props.visible !== prevProps.visible) {
      this.setState({ visible: this.props.visible })
    }
  }

  show () {
    this.setState({ visible: true })
  }

  hide () {
    this.setState({ visible: false })
  }

  polimorphicContent () {
    return (
      <>
        {typeof this.props.content === 'object'
          ? (
              this.props.content
            )
          : (
            <Text
              style={{
                ...this.props.style,
                font: 'bold',
                fontSize: '20px',
                marginBottom: '20',
                ...centerHorizontally
              }}
              value={this.props.content}
            />
            )}

        {this.props.action && (
          <>
            <div
              className='action-buttons'
              style={{ marginBottom: '10px', marginTop: '30px', ...centerHorizontally }}
              onClick={(event) => event.stopPropagation()}
            >
              {!this.props.onlyYes && (
                <Button
                  rich
                  secondary
                  label={this.props.no || 'No'}
                  icon='close'
                  inverted
                  onClick={this.hide}
                  style={{ marginRight: 20 }}
                />
              )}
              <Button
                rich
                label={this.props.yes || 'Si'}
                icon='check'
                style={{ backgroundColor: '#004680', color: 'white' }}
                styleText={{ color: 'white' }}
                onClick={() => {
                  this.props.action()
                  if (this.props.keepShowingOnSave) {
                    this.hide()
                  }
                }}
              />
            </div>
          </>
        )}
      </>
    )
  }

  content () {
    return (
      <>
        <div style={{ marginBottom: '0.7rem' }} />
        {this.props.closable !== 'no'
          ? (
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              justifyContent: 'flex-end',
              backgroundColor: 'transparent',
              paddingRight: '1.2rem',
              marginTop: '0.8rem',
              position: 'absolute',
              right: '0.1rem',
              top: '0.8rem',
              zIndex: 1
            }}
            >
              <Icon
                color='white'
                name='close'
                size={24}
                style={{ cursor: 'pointer', marginBottom: 10 }}
                onClick={() => this.hide()}
                secondary
              />
            </div>)
          : null}
        {this.polimorphicContent()}
      </>
    )
  }

  render () {
    return (
      <MuiDialog
        open={this.state.visible}
        onClose={this.props?.noDismissable ? undefined : this.hide}
        maxWidth={false}
        PaperProps={{
          sx: {
            backdropFilter: 'blur(16px) saturate(90%)',
            background: 'repeating-linear-gradient(315deg, rgba(0, 255, 255, 0.38) 92%, rgba(7, 58, 255, 0) 100%), repeating-radial-gradient(75% 75% at 238% 118%, rgba(0, 255, 255, 0.07) 30%, rgba(7, 58, 255, 0.08) 39%), radial-gradient(99% 99% at 109% 2%, rgba(32, 0, 255, 0.73) 0%, rgba(7, 58, 255, 0) 100%), radial-gradient(99% 99% at 21% 78%, rgb(123, 0, 255) 0%, rgba(7, 58, 255, 0) 100%), radial-gradient(160% 154% at 711px -303px, rgb(7, 255, 55) 349%, rgb(7, 58, 255) 134%)',
            WebkitBackdropFilter: 'blur(16px) saturate(180%)',
            overflowX: 'hidden',
            borderRadius: '20px',
            minWidth: 550,
            backgroundSize: 'cover',
            overflow: 'auto',
            scrollbarWidth: 'none',
            ...this.props.style,
            color: '#32324e',
            boxShadow: '0px 0px 57px -25px rgba(0,0,0,0.95)',
            ...this.props.styleContainer
          }
        }}
      >
        <DialogContent sx={{ padding: 0, overflow: 'visible' }}>
          {this.props.noCard
            ? this.content()
            : (
              <Card title={this.props.header} style={{ margin: '50px 50px', position: 'relative' }}>
                {this.content()}
              </Card>)}
        </DialogContent>
      </MuiDialog>
    )
  }
}

const centerHorizontally = {
  display: 'flex',
  justifyContent: 'center'
}

ModalGeneric.propTypes = {
  content: typeStringOrReact,
  setShow: PropTypes.func,
  setHide: PropTypes.func,
  header: typeStringOrReact,
  action: PropTypes.func,
  style: PropTypes.object,
  styleContainer: PropTypes.object,
  styleText: PropTypes.object,
  no: PropTypes.string,
  yes: PropTypes.string,
  onlyYes: PropTypes.bool,
  question: PropTypes.string
}
export { ModalGeneric }
